console.log('W3 nested cart override loaded');

window.poCustomSubmit = 1;
window.poSkipAddOns = 1;

window.productOptionsSubmitCallback = async function(formData) {
  console.log('W3 custom nested-cart submit started');

  try {
    const parentVariantId = Number(formData.get('id'));
    const parentQuantity = Number(formData.get('quantity')) || 1;

    const groupId = formData.get('properties[_options_group_id]');
    const addonJson = formData.get('properties[_options_addon_products]');

    if (!parentVariantId) {
      throw new Error('Could not determine the parent variant ID.');
    }

    let addons = [];

    if (addonJson) {
      addons = JSON.parse(addonJson);
    }

    console.log('Parent variant:', parentVariantId);
    console.log('Parent quantity:', parentQuantity);
    console.log('W3 group ID:', groupId);
    console.log('W3 add-ons:', addons);

    /*
     * Build the parent properties from the original W3 FormData.
     *
     * We keep normal W3 option properties such as:
     *   properties[1in. Ladder strap selection:]
     *   properties[Would you like to add a Pull Cord ?]
     *
     * and W3's private properties such as:
     *   _options_group_id
     *   _options_edit_url
     *   _options_addon_products
     */
    const parentProperties = {};

    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.*)\]$/);

      if (match) {
        parentProperties[match[1]] = value;
      }
    }

    const items = [
      {
        id: parentVariantId,
        quantity: parentQuantity,
        properties: parentProperties
      }
    ];

    /*
     * Turn each W3 add-on into a Shopify native nested child.
     */
    addons.forEach((addon) => {
      items.push({
        id: Number(addon.variantId),
        quantity: parentQuantity,
        parent_id: parentVariantId,
        properties: {
          _options_group_id: groupId,
          _options_hidden: 'true',
          _options_action: addon.actionID
        }
      });
    });

    console.log('Nested cart payload:', items);

    const response = await fetch(
      window.Shopify.routes.root + 'cart/add.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      }
    );

    const result = await response.json();

    console.log('Shopify cart/add response:', result);

    if (!response.ok) {
      throw new Error(
        result.description ||
        result.message ||
        'Shopify rejected the cart request.'
      );
    }

    console.log('Nested cart add succeeded');

    window.location.href = window.Shopify.routes.root + 'cart';

  } catch (error) {
    console.error('W3 nested cart error:', error);

    alert(
      'There was a problem adding this configuration to the cart.\n\n' +
      error.message
    );
  }
};